import script from "./RouteHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteHeader.vue?vue&type=script&setup=true&lang=js"

import "./RouteHeader.vue?vue&type=style&index=0&id=4c1de4f8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c1de4f8"]])

export default __exports__